module.exports = __webpack_public_path__ + "media/images/icons/link-broken-0c2f0c6729780b46bcaeea311c962e6d.svg";